// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./grid-system.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./display.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./width.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./margin.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./padding.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./utilities.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./fonts.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./externals.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./transitions.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_colors.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_typography.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_spacing.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_z-index.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_shadows.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_14___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_transitions.scss";
import ___CSS_LOADER_AT_RULE_IMPORT_15___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./tokens/_borders.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_14___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background-color: var(--background-color);
  font-family: "Inter", sans-serif;
  color: var(--m-text);
  font-size: 14px;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  line-height: 22px;
}

:root {
  --m-primary-color: #0c8479;
  --m-primary-color-hovered: #0a6f66;
  --m-primary-color-pressed: #085a53;
  --m-primary-color-disabled: #06453f;
  --m-primary-color-text: #ffffff;
  --m-primary-color-text-hovered: #ffffff;
  --m-primary-color-text-pressed: #ffffff;
  --m-primary-color-text-disabled: #ffffff;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #d1d6db;
  border-right: none;
  border-left: none;
}

::-webkit-scrollbar-track-piece:end {
  background: transparent;
}

::-webkit-scrollbar-track-piece:start {
  background: transparent;
}

.flex-container {
  display: flex;
}

.page-label {
  font-size: 1.25rem;
  font-weight: 500;
  color: #495057;
  line-height: 24px;
}

.page-label-dark {
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--m-white);
  line-height: 24px;
}

.code-color {
  color: var(--bs-code-color);
}

.bold {
  font-weight: bold;
}

.title-card {
  font-weight: 600;
  color: var(--m-text);
  font-size: 14px;
}

.title-page {
  color: var(--m-text);
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 20px;
  margin-bottom: 8px;
}

.sub-title-page {
  color: var(--m-text-light);
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.card-content {
  width: 100%;
  position: relative;
  background-color: var(--m-white);
  box-shadow: var(--m-box-shadow-car);
  border-radius: var(--m-border-radius);
  padding: 16px;
  border: 1px solid var(--m-subtle);
}
.card-content.light {
  background-color: #fff;
}
.card-content.dark {
  background-color: #2a3042;
  color: rgba(255, 255, 255, 0.9);
  box-shadow: unset;
}

.card {
  width: 100%;
  position: relative;
  background-color: var(--m-card-background-color);
  border-radius: var(--m-border-radius-md);
  border: 1px solid var(--m-border-card-file);
  box-shadow: var(--m-box-shadow-car);
}
.card.light {
  background-color: #fff;
}
.card.dark {
  background-color: #2a3042;
  color: rgba(255, 255, 255, 0.9);
  box-shadow: unset;
}

.u-pointer {
  cursor: pointer;
}

.avatar-24 {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar-24 img {
  width: 100%;
  object-fit: contain;
}

.full-border {
  border: 1px solid #ccc;
}

.text-through {
  text-decoration: line-through;
}

.label {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}

[m-data-theme=dark] ::-webkit-scrollbar-thumb {
  background-color: var(--m-scrollbar-color-hovered);
}
[m-data-theme=dark] .page-header-card {
  background: linear-gradient(135deg, var(--m-card-background-color) 0%, rgba(34, 39, 53, 0.9) 100%);
  border-color: var(--m-border-color);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}
[m-data-theme=dark] .stat-card {
  background: var(--m-card-background-color);
  border-color: var(--m-border-color);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
[m-data-theme=dark] .stat-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
  border-color: rgba(12, 132, 121, 0.4);
}
[m-data-theme=dark] .subtitle-item {
  background: rgba(12, 132, 121, 0.12);
  border-color: rgba(12, 132, 121, 0.25);
}

.page-header-card {
  background: linear-gradient(135deg, var(--m-card-background-color, #ffffff) 0%, var(--m-subtle-card-background-color, #f8f9fa) 100%);
  border: 1px solid var(--m-border-color, #e9ecef);
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  position: relative;
}

.page-header-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #0c8479 0%, #20c997 100%);
}

.page-header-content {
  padding: 20px;
}

.page-header-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 20px;
}

.page-header-title-section {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.back-button {
  align-self: flex-start;
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.back-button:hover {
  transform: translateX(-2px);
  box-shadow: 0 4px 12px rgba(12, 132, 121, 0.15);
}

.page-title-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.page-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  line-height: 1.2;
  background: linear-gradient(135deg, #0c8479 0%, #20c997 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-subtitle {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.subtitle-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 10px;
  background: rgba(12, 132, 121, 0.05);
  border-radius: 6px;
  border: 1px solid rgba(12, 132, 121, 0.1);
}

.subtitle-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: #0c8479;
  font-size: 12px;
}

.subtitle-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.subtitle-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--m-text-muted, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.subtitle-value {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--m-text, #1a1a1a);
}

.subtitle-value.highlight {
  color: var(--m-primary, #0c8479);
  font-weight: 700;
}

.subtitle-divider {
  width: 1px;
  height: 24px;
  background: var(--m-border-color, #e9ecef);
}

.page-header-stats {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: var(--m-card-background-color, #ffffff);
  border: 1px solid var(--m-border-color, #e9ecef);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.2s ease;
  min-width: 120px;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border-color: rgba(12, 132, 121, 0.2);
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0c8479 0%, #20c997 100%);
  border-radius: 8px;
  color: white;
  font-size: 14px;
}

.stat-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-number {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--m-text, #1a1a1a);
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  font-weight: 500;
  color: var(--m-text-muted, #6c757d);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

@media (max-width: 768px) {
  .page-header-content {
    padding: 16px;
  }
  .page-header-main {
    flex-direction: column;
    gap: 16px;
  }
  .page-title {
    font-size: 1.25rem;
  }
  .page-subtitle {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  .subtitle-divider {
    display: none;
  }
  .page-header-stats {
    width: 100%;
    justify-content: space-between;
  }
  .stat-card {
    flex: 1 1;
    min-width: auto;
  }
}
@media (max-width: 576px) {
  .page-header-content {
    padding: 16px;
  }
  .page-title {
    font-size: 1.1rem;
  }
  .page-header-stats {
    flex-direction: column;
    gap: 8px;
  }
  .stat-card {
    padding: 10px 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/_styles.scss"],"names":[],"mappings":"AAwBA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAFF;;AAKA;EACE,yCAAA;EACA,gCAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;AAFF;;AAIA;EACE,0BAAA;EACA,kCAAA;EACA,kCAAA;EACA,mCAAA;EACA,+BAAA;EACA,uCAAA;EACA,uCAAA;EACA,wCAAA;AADF;;AAGA;EACE,UAAA;EACA,WAAA;AAAF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,0BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,mCAAA;EACA,qCAAA;EACA,aAAA;EACA,iCAAA;AACF;AACE;EACE,sBAAA;AACJ;AAEE;EACE,yBAAA;EACA,+BAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,wCAAA;EAEA,2CAAA;EACA,mCAAA;AAFF;AAIE;EACE,sBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,+BAAA;EACA,iBAAA;AAHJ;;AAOA;EACE,eAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJF;AAME;EACE,WAAA;EAEA,mBAAA;AAJJ;;AAQA;EACE,sBAAA;AALF;;AAQA;EACE,6BAAA;AALF;;AAQA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AALF;;AASE;EACE,kDAAA;AANJ;AASE;EACE,kGAAA;EACA,mCAAA;EACA,0CAAA;AAPJ;AAUE;EACE,0CAAA;EACA,mCAAA;EACA,wCAAA;AARJ;AAUI;EACE,0CAAA;EACA,qCAAA;AARN;AAYE;EACE,oCAAA;EACA,sCAAA;AAVJ;;AAaA;EACE,oIAAA;EACA,gDAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,4DAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAaA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;AAVF;;AAaA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVF;;AAaA;EACE,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AAVF;;AAaA;EACE,2BAAA;EACA,+CAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAVF;;AAaA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,yCAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;AAVF;;AAaA;EACE,mBAAA;EACA,gBAAA;EACA,6BAAA;AAVF;;AAaA;EACE,gCAAA;EACA,gBAAA;AAVF;;AAaA;EACE,UAAA;EACA,YAAA;EACA,0CAAA;AAVF;;AAaA;EACE,aAAA;EACA,SAAA;EACA,cAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mDAAA;EACA,gDAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,2BAAA;EACA,0CAAA;EACA,qCAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAVF;;AAaA;EACE,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,yBAAA;EACA,qBAAA;AAVF;;AAaA;EACE;IACE,aAAA;EAVF;EAaA;IACE,sBAAA;IACA,SAAA;EAXF;EAcA;IACE,kBAAA;EAZF;EAeA;IACE,sBAAA;IACA,uBAAA;IACA,SAAA;EAbF;EAgBA;IACE,aAAA;EAdF;EAiBA;IACE,WAAA;IACA,8BAAA;EAfF;EAkBA;IACE,SAAA;IACA,eAAA;EAhBF;AACF;AAmBA;EACE;IACE,aAAA;EAjBF;EAoBA;IACE,iBAAA;EAlBF;EAqBA;IACE,sBAAA;IACA,QAAA;EAnBF;EAsBA;IACE,kBAAA;EApBF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Quicksand:wght@300..700&display=swap\");\n\n@import url(\"./grid-system.scss\");\n@import url(\"./display.scss\");\n@import url(\"./width.scss\");\n@import url(\"./margin.scss\");\n@import url(\"./padding.scss\");\n@import url(\"./utilities.scss\");\n@import url(\"./fonts.scss\");\n@import url(\"./externals.scss\");\n@import url(\"./transitions.css\");\n\n@import url(\"./tokens/_colors.scss\");\n@import url(\"./tokens/_typography.scss\");\n@import url(\"./tokens/_spacing.scss\");\n@import url(\"./tokens/_z-index.scss\");\n@import url(\"./tokens/_shadows.scss\");\n@import url(\"./tokens/_transitions.scss\");\n@import url(\"./tokens/_borders.scss\");\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  background-color: var(--background-color);\n  font-family: \"Inter\", sans-serif;\n  color: var(--m-text);\n  font-size: 14px;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  line-height: 22px;\n}\n:root {\n  --m-primary-color: #0c8479;\n  --m-primary-color-hovered: #0a6f66;\n  --m-primary-color-pressed: #085a53;\n  --m-primary-color-disabled: #06453f;\n  --m-primary-color-text: #ffffff;\n  --m-primary-color-text-hovered: #ffffff;\n  --m-primary-color-text-pressed: #ffffff;\n  --m-primary-color-text-disabled: #ffffff;\n}\n::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: #d1d6db;\n  border-right: none;\n  border-left: none;\n}\n\n::-webkit-scrollbar-track-piece:end {\n  background: transparent;\n}\n\n::-webkit-scrollbar-track-piece:start {\n  background: transparent;\n}\n\n.flex-container {\n  display: flex;\n}\n\n.page-label {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: #495057;\n  line-height: 24px;\n}\n\n.page-label-dark {\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: var(--m-white);\n  line-height: 24px;\n}\n\n.code-color {\n  color: var(--bs-code-color);\n}\n\n.bold {\n  font-weight: bold;\n}\n\n.title-card {\n  font-weight: 600;\n  color: var(--m-text);\n  font-size: 14px;\n}\n\n.title-page {\n  color: var(--m-text);\n  font-weight: 500;\n  font-size: 1.25rem;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n\n.sub-title-page {\n  color: var(--m-text-light);\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.card-content {\n  width: 100%;\n  position: relative;\n  background-color: var(--m-white);\n  box-shadow: var(--m-box-shadow-car);\n  border-radius: var(--m-border-radius);\n  padding: 16px;\n  border: 1px solid var(--m-subtle);\n\n  &.light {\n    background-color: #fff;\n  }\n\n  &.dark {\n    background-color: #2a3042;\n    color: rgba(255, 255, 255, 0.9);\n    box-shadow: unset;\n  }\n}\n\n.card {\n  width: 100%;\n  position: relative;\n  background-color: var(--m-card-background-color);\n  border-radius: var(--m-border-radius-md);\n  // padding: 16px;\n  border: 1px solid var(--m-border-card-file);\n  box-shadow: var(--m-box-shadow-car);\n\n  &.light {\n    background-color: #fff;\n  }\n\n  &.dark {\n    background-color: #2a3042;\n    color: rgba(255, 255, 255, 0.9);\n    box-shadow: unset;\n  }\n}\n\n.u-pointer {\n  cursor: pointer;\n}\n\n.avatar-24 {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    -o-object-fit: contain;\n    object-fit: contain;\n  }\n}\n\n.full-border {\n  border: 1px solid #ccc;\n}\n\n.text-through {\n  text-decoration: line-through;\n}\n\n.label {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 20px;\n}\n\n[m-data-theme=\"dark\"] {\n  ::-webkit-scrollbar-thumb {\n    background-color: var(--m-scrollbar-color-hovered);\n  }\n\n  .page-header-card {\n    background: linear-gradient(135deg, var(--m-card-background-color) 0%, rgba(34, 39, 53, 0.9) 100%);\n    border-color: var(--m-border-color);\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n  }\n\n  .stat-card {\n    background: var(--m-card-background-color);\n    border-color: var(--m-border-color);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n\n    &:hover {\n      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);\n      border-color: rgba(12, 132, 121, 0.4);\n    }\n  }\n\n  .subtitle-item {\n    background: rgba(12, 132, 121, 0.12);\n    border-color: rgba(12, 132, 121, 0.25);\n  }\n}\n.page-header-card {\n  background: linear-gradient(135deg, var(--m-card-background-color, #ffffff) 0%, var(--m-subtle-card-background-color, #f8f9fa) 100%);\n  border: 1px solid var(--m-border-color, #e9ecef);\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  position: relative;\n}\n\n.page-header-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #0c8479 0%, #20c997 100%);\n}\n\n.page-header-content {\n  padding: 20px;\n}\n\n.page-header-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 20px;\n}\n\n.page-header-title-section {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.back-button {\n  align-self: flex-start;\n  border-radius: 8px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.back-button:hover {\n  transform: translateX(-2px);\n  box-shadow: 0 4px 12px rgba(12, 132, 121, 0.15);\n}\n\n.page-title-content {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.page-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #1a1a1a;\n  margin: 0;\n  line-height: 1.2;\n  background: linear-gradient(135deg, #0c8479 0%, #20c997 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.page-subtitle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.subtitle-item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 10px;\n  background: rgba(12, 132, 121, 0.05);\n  border-radius: 6px;\n  border: 1px solid rgba(12, 132, 121, 0.1);\n}\n\n.subtitle-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 16px;\n  height: 16px;\n  color: #0c8479;\n  font-size: 12px;\n}\n\n.subtitle-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.subtitle-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--m-text-muted, #6c757d);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.subtitle-value {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--m-text, #1a1a1a);\n}\n\n.subtitle-value.highlight {\n  color: var(--m-primary, #0c8479);\n  font-weight: 700;\n}\n\n.subtitle-divider {\n  width: 1px;\n  height: 24px;\n  background: var(--m-border-color, #e9ecef);\n}\n\n.page-header-stats {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.stat-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background: var(--m-card-background-color, #ffffff);\n  border: 1px solid var(--m-border-color, #e9ecef);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);\n  transition: all 0.2s ease;\n  min-width: 120px;\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  border-color: rgba(12, 132, 121, 0.2);\n}\n\n.stat-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: linear-gradient(135deg, #0c8479 0%, #20c997 100%);\n  border-radius: 8px;\n  color: white;\n  font-size: 14px;\n}\n\n.stat-content {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.stat-number {\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--m-text, #1a1a1a);\n  line-height: 1;\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: var(--m-text-muted, #6c757d);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n@media (max-width: 768px) {\n  .page-header-content {\n    padding: 16px;\n  }\n\n  .page-header-main {\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  .page-title {\n    font-size: 1.25rem;\n  }\n\n  .page-subtitle {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .subtitle-divider {\n    display: none;\n  }\n\n  .page-header-stats {\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .stat-card {\n    flex: 1;\n    min-width: auto;\n  }\n}\n\n@media (max-width: 576px) {\n  .page-header-content {\n    padding: 16px;\n  }\n\n  .page-title {\n    font-size: 1.1rem;\n  }\n\n  .page-header-stats {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .stat-card {\n    padding: 10px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
